/*
Renders an ol map
*/
import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");
import View = require("./view");

const log = Utils.log;

class Control extends View {

    static about = `
Used by applications/rhythm-gis-app to render the map.
    `;

    static options = Utils.defaults({
        "region": {
            "default": "map-region",
        },
        "view": {
            "default": "app/views/MapView",
        },
    }, View.options);

    execute(args = this.args) {
        // do anything that needs to be done before the view gets created here
        let options = _.defaults(this.options, {
            view: Control.options.view.default,
            region: Control.options.region.default,
        });

    }

    setViewOptions(options) {
        // temporary, working toward a classic controller created from configuration
        let applet = <Portal.MapApplicationElement>this.args["applet"];

        // TODO: move into broadcast because mapView is this.view
        this.mediator.mapView(mapView => {
            console.assert(mapView === this.view, "mapView is this.view");
            // foward mapView events
            applet.Events.Events
                .filter(event => !event.disabled && event.name.indexOf("map-") === 0)
                .forEach(event => {
                log("register event forwarding: ", event.name);
                mapView.on(event.name, args => {
                    log("mapView event:", event.name);
                    this.trigger(event.name, args);
                });

            });

        });

        // the "maplet" is used as the model in MapView...not sure why I did this, though
        _.defaults(options, {
            maplet: applet.Map
        });

        return super.setViewOptions(options);
    }

    broadcast() {

        let forwardEvents = "show-layer,hide-layer".split(",");
        forwardEvents.forEach(event => {
            log("forwarding event: ", event);
            this.view.on(event, args => this.trigger(event, args));
        });

        this.mediator.model.set("mapView", this.view);
        log("mediator notified of 'mapView'");

        super.broadcast();
    }

}

export = Control; 